import { useEffect, useState } from "react";
import { blogs, BlogPost } from "../../data/blogData";
import { SectionHeader } from "../layout/SectionHeader";

const Blogs = () => {
  const [selectedBlog, setSelectedBlog] = useState<BlogPost | null>(null);

  useEffect(() => {
    document.body.style.overflow = selectedBlog ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedBlog]);

  return (
    <section className="blogsPage">
      <div className="container">
        <SectionHeader
          num="06"
          command="> ls ~/blog"
          caption={`${blogs.length} entries`}
        />

        <ul className="blogGrid">
          {blogs.map((b) => (
            <li key={b.id}>
              <button
                type="button"
                className="blogCard"
                onClick={() => setSelectedBlog(b)}
              >
                <header className="blogCard__head">
                  <span className="blogCard__date">[{b.date}]</span>
                  <span className="blogCard__time">+4 min</span>
                </header>
                <h3 className="blogCard__title">{b.title}</h3>
                <p className="blogCard__preview">{b.preview}</p>
                <ul className="blogCard__tags">
                  {b.tags.map((t) => (
                    <li key={t}>{t}</li>
                  ))}
                </ul>
              </button>
            </li>
          ))}
        </ul>
      </div>

      {selectedBlog && (
        <div
          className="blogModal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="blogModalTitle"
          onClick={() => setSelectedBlog(null)}
        >
          <article
            className="blogModal__content"
            onClick={(e) => e.stopPropagation()}
          >
            <header className="blogModal__head">
              <span className="blogModal__path">
                <span className="blogModal__prefix">./</span>
                {selectedBlog.title.toLowerCase().replace(/\s+/g, "-")}
              </span>
              <button
                type="button"
                className="blogModal__close"
                onClick={() => setSelectedBlog(null)}
                aria-label="Close"
              >
                ×
              </button>
            </header>
            <h2 id="blogModalTitle" className="blogModal__title">
              {selectedBlog.title}
            </h2>
            <span className="blogModal__date">[{selectedBlog.date}]</span>
            <div
              className="blogModal__body"
              dangerouslySetInnerHTML={{ __html: selectedBlog.content }}
            />
          </article>
        </div>
      )}
    </section>
  );
};

export default Blogs;
